import { Text, useTexture } from '@react-three/drei'
import Image from './Image'
import Link from './Link'

const ProjectEntry = ({ title, blurb, link, url, image, position, rotation, offset = 0, ...props }) => {  
    // Images
    const img = useTexture(image)

    // Positions
    const titlePosition = [position[0], position[1], position[2] + offset]
    const linkPosition = [position[0], position[1], position[2] + offset + 0.85]
    const blurbPosition = [position[0], position[1], position[2] + offset + 1.7]
    const imagePosition = [position[0] + 10, position[1], position[2] + offset + 3.15]
  
    return (
      <group {...props}>
  
        {/* Project Title */}
        <Text font="./fonts/Lato-Regular.ttf" fontSize={0.75} color="#ffffff" position={titlePosition} rotation={rotation} maxWidth={15} anchorX='left' anchorY='top' >
          {title}
        </Text>

        <Link url={url} font="./fonts/Lato-Italic.ttf" fontSize={0.6} color="#ffffff" position={linkPosition} rotation={[-Math.PI / 2, 0, 0]}>
            {link}
        </Link>

        <Text font="./fonts/Lato-Regular.ttf" fontSize={0.4} color="#ffffff" position={blurbPosition} rotation={rotation} maxWidth={7.5} anchorX='left' anchorY='top' >
          {blurb}
        </Text>

        <Image map={img} args={[4, 4]} position={imagePosition} rotation={[-Math.PI / 2, 0, 0]} />
  
      </group>
    )
  }
  
  export default ProjectEntry